import { type ParentComponent, onMount } from 'solid-js'
import { Box, Grid } from 'styled-system/jsx'
import { RouteGuard } from './RouteGuard'
import { Splash } from './Splash'
import { Header } from './components/Header'
import Toast from './core/Toast'
import { usePushEvents } from './core/usePushEvents'

export const Container: ParentComponent = (props) => {
  onMount(() => {
    usePushEvents()
  })
	return (
		<Box pt='var(--safe-area-inset-top)' pb='var(--safe-area-inset-bottom)'>
			<RouteGuard>
				<Splash>
					<Grid
						p={3}
						gap={3}
					>
						<Header />
						{props.children}
					</Grid>
					<Toast />
				</Splash>
			</RouteGuard>
		</Box>
	)
}

export default Container
